import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Form } from "antd";

import {
    accessManagementSetShowUserModal,
    accessManagementSetModeUserModal
} from '../../../../store/actions/accessManagementActions';

import AccountModal from "../../../../commons/components/AccountModal"
import AccountInput from "../../../../commons/components/AccountInput/index";
import Loading from "../../../../commons/components/loading";
import AccountToggle from "../../../../commons/components/AccountToggle";

import newUserModalModes from './newUserModalModes'
import Utils from "../../../../commons/utils/utils";
import Http from "../../../../commons/utils/Http";
import Message from "../../../../commons/utils/message";

import { ErrorText } from './newUserModalStyles';

function NewUserModal({ onSave }) {
    const dispatch = useDispatch();
    const { selectedPartner, showUserModal, modeUserModal } = useSelector(state => state.accessManagement);

    const [loading, setLoading] = useState(false);

    const [email, setEmail] = useState("");
    const [errorEmail, setErrorEmail] = useState("");

    const [partner, setPartner] = useState({});
    const [errorPartner, setErrorPartner] = useState("");

    const [selectedRoles, setSelectedRoles] = useState([]);
    const [errorRoleSelect, setErrorRoleSelect] = useState("");

    const [partners, setPartners] = useState([]);

    const [roleData, setRoleData] = useState([]);
    const [roleTreeExpanded, setRoleTreeExpanded] = useState([]);

    useEffect(() => {
        getRoleData();
    }, []);

    function searchPartners(search) {
        Http.get(`/partners/search?search=${search}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setPartners(formatSelectPartnersData(responseData.data));
                }
            }).catch(err => {
                setPartners([]);
            })
    }

    function getRoleData() {
        setLoading(true);
        Http.get(`/roles/roles-and-applications`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {

                    let applicationRoles = [];

                    let result = Utils.isDevPartner(selectedPartner) ? Utils.filterDataToDevPartner(responseData.data) : responseData.data;

                    result.map((dataItem) => {
                        if (dataItem.access_management == true) {
                            let application = { title: dataItem.name, key: dataItem.id, id: dataItem.id };
                            let roles = [];
                            dataItem.roles.map((dataRole) => {
                                let role = { title: dataRole.name, key: dataItem.id + '-' +dataRole.id, id: dataRole.id }
                                roles.push(role);
                            })
                            application.children = roles;
                            applicationRoles.push(application);
                        }
                    })

                    setRoleData(applicationRoles)
                    setLoading(false);
                }
            }).catch(err => {
                setRoleData([]);
                setLoading(false);
            })
    }

    async function insertUser(body) {
        try {
            let response = await Http.post(`/users`, body, Http.headers);
            return response;
        } catch (error) {
            if (error.response) {
                Message.showError(error.response.data.response.message);
            }
            else {
                Message.showError("Erro ao inserir usuário");
            }
        }
    }

    function formatSelectPartnersData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                if (dataItem.id != 1 && dataItem.trading_name != "PARCEIRO DEFAULT") {
                    item.label = `${dataItem.codparc + " - " + dataItem.trading_name}`;
                    item.value = dataItem.id;
                    array.push(item)
                }
            })
        }
        return array;
    }

    function renderButtons() {
        if (modeUserModal == newUserModalModes.VIEW) {
            return (
                <button key="cancel" onClick={handleClear} className="ant-btn ant-btn-primary">Ok</button>
            )
        } else {
            return (
                <>
                    <button key="cancel" onClick={handleClear} className="ant-btn">Cancelar</button>
                    <button key="confirm" onClick={handleSave} className="ant-btn ant-btn-primary">Salvar</button>
                </>
            )
        }
    }

    function handleClear() {
        dispatch(accessManagementSetShowUserModal(false));
        dispatch(accessManagementSetModeUserModal(null));

        setEmail(null);
        setErrorEmail("");

        setPartner({});
        setErrorPartner("");

        setSelectedRoles([]);
        setErrorRoleSelect("");

        setPartners([]);
        setRoleTreeExpanded([]);

        setLoading(false);
    }

    async function handleSave() {
        if (validateForm()) {

            let body = {
                "email": email,
                "partner_id": selectedPartner.partner_id,
            };

            let bodyRoles = [];

            roleData.map((application) => {
                application.children.map((role) => {
                    if (selectedRoles.includes(role.key)) {
                        bodyRoles.push({
                            "application_id": application.id,
                            "partner_id": selectedPartner.partner_id,
                            "role_id": role.id,
                        })
                    }
                })
            })
            body.roles = bodyRoles;

            setLoading(true);

            const responseInsert = await insertUser(body);
                if(responseInsert) {
                    if (responseInsert.data && !responseInsert.data.response.error) {
                        Message.showSuccess(responseInsert.data.response.message);
                        onSave();
                        handleClear();
                    }
                }

            setLoading(false);

        }
    }

    function validateForm() {
        let valid = true;

        if (!email) {
            setErrorEmail("Informe um e-mail");
            valid = false;
        } else if (!Utils.validateEmail(email)) {
            setErrorEmail("Informe um e-mail válido");
            valid = false;
        }

        if (selectedRoles.length == 0) {
            setErrorRoleSelect("Marque pelo menos uma opção");
            valid = false;
        }

        return valid;
    }

    function handleOnSearchPartner(search) {
        searchPartners(search);
        setErrorPartner("");
    }

    function handleOnChangePartner(partnerId) {
        setPartner(partners.find(partner => partner.value == partnerId));
        setErrorPartner("");
    }

    function handleOnChangeEmail(input) {
        setEmail(input.target.value);
        setErrorEmail("");
    }

    function handleOnChangeCheckedValue(input) {
        if(input.target.checked) {
            setSelectedRoles([...selectedRoles, input.target.id]);
            setErrorRoleSelect("");
        } else {
            setSelectedRoles( selectedRoles.filter(role => role != input.target.id) );
        }
        
        if(selectedRoles.length != 0)  {
            setErrorRoleSelect("");
        }
    }

    function renderPermissionsList() {
        return (
            <>
                <strong>Permissões:</strong>
                <div style={errorRoleSelect ? { maxHeight: 350, overflow: 'auto', border: 'solid 1px #f10b3c', borderRadius: 12, padding: 5 } : { maxHeight: 350, overflow: 'auto' }} >
                    {
                        roleData.map((data, key) => {
                            return (
                                <div key={key}>
                                    <p style={{ marginTop: 15, marginBottom: 5 }}>{data.title}</p>
                                    <AccountToggle data={data} key={key} onChange={(value) => handleOnChangeCheckedValue(value)} error={errorRoleSelect}></AccountToggle>
                                </div>
                            )
                        })
                    }
                </div>
                {errorRoleSelect && <ErrorText>{errorRoleSelect}</ErrorText>}
            </>
        );
    }

    function renderForm() {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <Form>
                    <Form.Item>
                        <AccountInput
                            placeholder={"E-mail"}
                            value={email}
                            onChange={(value) => handleOnChangeEmail(value)}
                            error={errorEmail} />
                    </Form.Item>
                    
                    <Form.Item>
                        { renderPermissionsList() }
                    </Form.Item>
                </Form>
            )
        }
    }

    return (
        <AccountModal
            visible={showUserModal}
            title={"Criar novo usuário"}
            onCancel={handleClear}
            footer={renderButtons()}>
            {renderForm()}
        </AccountModal>
    )
}

export default NewUserModal;

